<template>
  <div id="offcanvas" uk-offcanvas="mode: push" overlay>
    <div class="uk-offcanvas-bar">
      <button class="uk-offcanvas-close" type="button" uk-close></button>

      <div class="link-container">
        <router-link class="link" :class="{'active': thisRoute == 'home'}" to="/">home</router-link>
        <router-link
          class="link"
          :class="{'active': thisRoute == 'services'}"
          to="/services"
        >diensten</router-link>
        <router-link
          class="link"
          :class="{'active': thisRoute == 'vacancies'}"
          to="/vacancies"
        >vacatures</router-link>
        <router-link class="link" :class="{'active': thisRoute == 'about'}"
        to="/about">over ons</router-link>
        <router-link class="link" :class="{'active': thisRoute == 'contact'}"
        to="/contact">contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit';

export default {
  watch: {
    $route: {
      deep: true,
      handler() {
        UIkit.offcanvas('#offcanvas').hide();
      },
    },
  },
  computed: {
    thisRoute() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="less" scoped >
@import "../assets/vars.less";

.uk-offcanvas-bar {
  background-color: gray;
}

.link-container {
  margin-top: 4rem;
}

.link {
  display: block;
  margin-top: 0.5rem;
  color: @primary-color;
  font-family: "Space Mono";
  font-size: 1.3rem;
  text-transform: uppercase;
  &:hover {
    text-decoration: none;
    color: @primary-color-hover;
  }
  &.active {
    color: @primary-color-active-light;
  }
}
</style>
